import {checkExtensionsString, CREATE_MODE} from "../utils";
import {isIDValidWithHelp} from "../../../../../../utils/artefactValidators";
import {ID_MAX_LEN} from "../../../../../../constants/generals";

const isFieldRequiredFilledIn = (t, value) => {
    if (!value || (value && !value.trim())) {
        return {help: t("commons.alerts.requiredField.content")};
    }
    return {help: ""}
};

const isIDUnique = (t, id, allIds) => {
    return !allIds.includes(id) ? {valid: true, help: ""} : {valid: false, help: t("validators.id.shouldBeUnique")}
}

const isTextFieldTooLong = (t, text) => {
    return text && text.length > ID_MAX_LEN ? {
        valid: false,
        help: t('commons.alerts.fieldTooLong.content', {maxLen: ID_MAX_LEN})
    } : {valid: true, help: ""}
}

export const isPluginUidInvalid = (modalInfo, value, allIDs, t, isRequired = true) => modalInfo.mode === CREATE_MODE &&
    (isIDValidWithHelp(t, value).help ||
        isTextFieldTooLong(t, value).help ||
        isIDUnique(t, value, allIDs).help ||
        (isRequired && isFieldRequiredFilledIn(t, value).help))

export const isMultiLangNameInvalid = (t, value, isRequired = true) => {
    if (!value || (!value.en && !value.it)) {
        return isRequired ? t("commons.alerts.requiredField.content") : "";
    }
    const errors = ["en", "it"].map(lang => {
        if (!value[lang]) {
            return "";
        }
        if (isTextFieldTooLong(t, value[lang]).help) {
            return `${lang} - ${isTextFieldTooLong(t, value[lang]).help}`;
        }
        return "";
    }).join(", ");
    if (errors === ", ") {
        return "";
    }
    return errors;
};

export const isRequiredFieldAbsent = (t, value, isRequired = true) => isRequired && isFieldRequiredFilledIn(t, value).help;

export const areInputExtensionsInvalid = (t, extensions, isRequired = true) => {
    if (!extensions) {
        return isRequired ? t("commons.alerts.requiredField.content") : "";
    }
    if (!extensions.includes(".")) {
        return t("data.plugins.extensionsValidation.invalidString");
    }
    const splitExtensions = checkExtensionsString(extensions).split(";");
    return splitExtensions.every(e => e.includes(".") && e.replace(/^\.\w+/, "") === "") ? "" : t("data.plugins.extensionsValidation.invalidString");
}

export const isOutputExtensionInvalid = (t, extension, isRequired = true) => {
    if (!extension) {
        return isRequired ? t("commons.alerts.requiredField.content") : "";
    }
    return extension.replace(/^\.\w+/, "") === "" ? "" : t("data.plugins.extensionsValidation.invalidSingleExtension");

}

export const isIconColorInvalid = (t, iconColor, sequenceMappingColor) => {
    if (!iconColor || !sequenceMappingColor) {
        return ""
    }
    if (iconColor === sequenceMappingColor) {
        return t("data.plugins.extensionsValidation.invalidIconColors")
    }
    return ""
}

export const isPluginValid = (plugin, allIds, modalInfo, t) => {
    const isPluginEnabledForMainMenu = !!plugin.Enabled && !!plugin.MainMenuEnabled;
    const isPluginEnabledForMappingAndLoader = !!plugin.Enabled && !!plugin.FileMappingEnabled;
    return !isPluginUidInvalid(modalInfo, plugin.PluginUid, allIds, t) &&
        !isMultiLangNameInvalid(t, plugin.PluginName, isPluginEnabledForMappingAndLoader) &&
        !isMultiLangNameInvalid(t, plugin.MenuName, isPluginEnabledForMainMenu) &&
        !isRequiredFieldAbsent(t, plugin.DllName) &&
        !areInputExtensionsInvalid(t, plugin.InputExtensions) &&
        !isOutputExtensionInvalid(t, plugin.OutputExtension, isPluginEnabledForMainMenu) &&
        !isRequiredFieldAbsent(t, plugin.TransformExtension, !!plugin.TransformFileEnabled) &&
        !isRequiredFieldAbsent(t, plugin.ProcessExtension, !!plugin.ProcessFileEnabled) &&
        !isIconColorInvalid(t, plugin.IconColor, plugin.SequenceMappingIconColor);
}
